/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowcategorychosen3Inputs */

const en_aiflowcategorychosen3 = /** @type {(inputs: Aiflowcategorychosen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category chosen`)
};

const de_aiflowcategorychosen3 = /** @type {(inputs: Aiflowcategorychosen3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie gewählt`)
};

/**
* | output |
* | --- |
* | "Category chosen" |
*
* @param {Aiflowcategorychosen3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcategorychosen3 = /** @type {((inputs?: Aiflowcategorychosen3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcategorychosen3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcategorychosen3(inputs)
	return de_aiflowcategorychosen3(inputs)
});
export { aiflowcategorychosen3 as "aiFlowCategoryChosen" }